import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Tag, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
postSkillMacthes,
addToMatches,
removeFromMatches,
clearMatchesSuccess,
getSkillMatches } from
"../../../redux/actions";
import schedule_icon from "../../../assets/icons/healthicons_i-schedule-school-date-time-outline.png";
import cil_chat_bubble from "../../../assets/icons/colorless_cil_chat-bubble.png";
import { retractBid } from "../../../redux/actions";
// import PlaceBidModal from "../../components/PlaceBidModal/PlaceBidModal";
import moment from "moment";
import PlaceBidModal from "../../../components/PlaceBidModal/PlaceBidModal";
import { LoadingOutlined } from "@ant-design/icons";

import TopAlert from "../../../components/TopNotification/TopAlert";
import history from "../../../routes/history";
import cil_chat_bubble_img from "../../../assets/img/cil_chat-bubble.png";
import { getCookie, getGigDetails, isNonHC } from "../../../shared/helpers";
import "../ProfileD.css";

export const Inprogressbtns = () => {


































  // <>
  //     <Row style={{ textAlign: 'center', width: '94%', margin: 'auto' }}>
  //         <Col className='edit-btn-div' xs={12}>
  //             <Button className='edit-bid-btn'>Edit Bid</Button>
  //         </Col>
  //         <Col className='retract-bid-btn-div' xs={12}>
  //             <Button className='retract-btn' onClick={showModal}>Retract Bid</Button>
  //         </Col>
  //     </Row>
  //     <Col lg={24} xs={24} ><button className='place-Bid-btn' onClick={placeABidFunction}>Place a Bid</button></Col>
  //     <Col lg={24} xs={24} ><button className='Bid-btn'>
  //         <img src={schedule_icon} />
  //         Schedule an Interview</button></Col>
  //     <Col lg={24} xs={24} ><button className='msg-btn'>job-listing.img
  //         <img src={cil_chat_bubble} className='social-icon' />
  //         Message Candidate</button></Col>
  // </>
};const authToken = getCookie("token");export const HiredStatusbtns = ({ chaticon, disChatIcon, messageCandidate, isInvited = false }) => {const messageId = useSelector((state) => state.getProfileDetailsReducer?.conversationID?.ConversationId);return <>
      <Col lg={24} xs={24}>
        <button className="place-Bid-btn-disabled">Place a bid</button>
      </Col>
      <Col lg={24} xs={24}>
        <button className="Bid-btn-disabled">
          <img src={schedule_icon} />
          Schedule an interview
        </button>
      </Col>
      <Col lg={24} xs={24}>
        <button onClick={messageId ? messageCandidate : null} className={messageId ? "msg-btn" : "cand-prof-msg-btn-disabled"}>
          <img src={messageId ? cil_chat_bubble_img : disChatIcon} className="social-icon" disabled={messageId ? false : true} />
        
          Message candidate
        </button>
      </Col>

      {isInvited ? null : <p style={{ textAlign: "left", paddingLeft: "3%", fontSize: "12px", color: "#7e7e7e", marginTop: "2%" }}>
      
          You can’t place a bid to the candidate if they’re status is “offer
          accepted”, “hired”, or “on billing”.
        </p>}
    
    </>;};export const PlacedBidBtns = (props) => {const dispatch = useDispatch();const [Pdetails, setPdetails] = useState([]);const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [TopAlertVisible, setTopAlertVisible] = useState(false);

  const [placebidModal, setplacebidModal] = useState(false);
  const bidData = useSelector((state) => state.createBidReducers.bidData);
  const editBidData = useSelector((state) => state.updateBidReducers.success);
  const professionCode = JSON.parse(localStorage.getItem("userProfile"));

  const RetractLoading = useSelector(
  (state) => state.retractBidReducers.loading);

  const RetractSuccess = useSelector(
  (state) => state.retractBidReducers.success);

  const RetractError = useSelector((state) => state.retractBidReducers.error);
  const bidUpdateSuccess = useSelector(
  (state) => state.updateBidReducers.success);


  // const Pdetails = useSelector(
  //   (state) => state.getProfileDetailsReducer.details
  // );

  const userSKillListing = useSelector(
  (state) => state.oneUserskillListingReducer.skillListings);


  useEffect(() => {
    if (userSKillListing)
    setPdetails({ ...(userSKillListing || {}), skill_listings: [userSKillListing?.skill_listings || {}] });
  }, [userSKillListing]);


  const showModal = () => {
    setVisible(true);
  };
  const showModal2 = () => {
    setVisible2(true);
  };
  const handleOk = () => {
    dispatch(
    retractBid({
      BidStatusName: "Retracted",
      // id: props.userSkillData.bid[0]._id,
      id: props.userSkillData?.bid[0]?.BidId,
      Message: "Bid was retracted",
      FromMsg: true,
      SkillListingId: props.userSkillData.bid[0].SkillListingId
    }));

    setTopAlertVisible(true);
    props.disableDownloadButton(false);
  };

  const PosbidStatuses = {
    10: "Interview Completed",
    25: "Offer Accepted",
    13: "Profile Submitted",
    7: "Interview Accepted",
    2: "Accepted",
    6: "Interview"
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const skillListing = Pdetails?.skill_listings?.[0];

  let desired_rate = 0;

  if (skillListing) {
    if (!isNonHC(professionCode?.Professions?.ProfessionCode)) {
      desired_rate =
      skillListing?.MinimumBid ??
      skillListing?.MinimumBid?.$numberDecimal ??
      0;
    } else {
      desired_rate =
      skillListing?.ClientRate ??
      parseFloat(skillListing?.ClientRate?.$numberDecimal)?.toFixed(2) ??
      0;
    }
  }

  const candidateList = () => [
  {
    id: Pdetails?.skill_listings?._id,
    AccountId: Pdetails?.skill_listings?.[0]?.Profiles?.Accounts?.AccountId,
    email: Pdetails?.skill_listings?.[0]?.Profiles?.Accounts?.EmailAddress,
    MobilePhone: Pdetails?.user_Schema?.Profiles?.MobilePhone,
    //  img: profilePic && profilePic,
    img:
    Pdetails?.user_Schema?.Profiles?.PictureUrl ??
    userSKillListing?.user_Schema?.Profiles?.PictureUrl,
    name:
    userSKillListing?.user_Schema?.Profiles?.FirstName +
    " " +
    userSKillListing?.user_Schema?.Profiles?.LastName ??
    userSKillListing?.user_Schema?.Profiles?.FirstName +
    " " +
    userSKillListing?.user_Schema?.Profiles?.LastName,
    experience: userSKillListing?.user_Schema?.Profiles?.ExperienceLevels?.
    ExperienceLevelName ?
    userSKillListing?.user_Schema?.Profiles?.ExperienceLevels?.
    ExperienceLevelName :
    null,
    title:
    Pdetails?.skill_listings?.length > 0 &&
    Pdetails?.skill_listings?.[0]?.Title,
    desired_rate: desired_rate,
    // title: userSKillListing?.user_Schema?.DraftSkillListing?.Title,

    bidType:
    Pdetails?.skill_listings?.length > 0 &&
    Pdetails?.skill_listings?.[0]?.BudgetTypes?.BudgetTypeName,
    lastActive: Pdetails?.user_Schema?.LastLoginDate ?
    moment(Pdetails?.user_Schema?.LastLoginDate).fromNow()
    // lastActive: userSKillListing?.user_Schema?.LastLoginDate
    //   ? moment(userSKillListing?.user_Schema?.LastLoginDate).fromNow()
    : "N/A"
    // rateType: userSKillListing?.bid?.length>0 && userSKillListing?.bid[0]?.BudgetTypeId,
    //   profileType: profileTypeRes?.profile?.ProfessionCode
  }];


  const placeBidModalVisisblityHandler = (value) => {
    setplacebidModal(value);
  };

  return (
    <>
      <Modal
      title="Retract Bid?"
      visible={visible}
      onCancel={handleCancel}
      width={450}
      centered
      // okText={'Yes'}
      // cancelText={'No'}
      footer={[
      <>
            <Button onClick={handleCancel} className="modal-no-retract">
              No, go back
            </Button>
            <Button onClick={handleOk} className="modal-ok-retract ">
              {RetractLoading ? <LoadingOutlined /> : "Yes , delete it"}
            </Button>
          </>]}>

        
        <p>Do you want to retract your placed bid?</p>
      </Modal>

      <PlaceBidModal
      fromMatches={props.fromMatches}
      visible={visible2}
      placeBidModalVisisblityHandler={setVisible2}
      rateType={
      bidUpdateSuccess?.BudgetTypeId ?
      bidUpdateSuccess?.BudgetTypeId :
      userSKillListing?.bid?.length > 0 &&
      userSKillListing?.bid?.[0]?.BudgetTypeId}

      multiBid={false}
      EditBid={true}
      Description={
      bidUpdateSuccess?.Comments ?
      bidUpdateSuccess?.Comments :
      userSKillListing?.bid?.length > 0 &&
      userSKillListing?.bid?.[0]?.Comments}

      IdealConLength={
      bidUpdateSuccess?.IdealTerm ?
      bidUpdateSuccess?.IdealTerm :
      userSKillListing?.bid?.length > 0 &&
      userSKillListing?.bid?.[0]?.IdealTerm}

      IdealStartDate={
      bidUpdateSuccess?.IdealStartDate ?
      moment(bidUpdateSuccess?.IdealStartDate).format("MMMM DD, YYYY") :
      moment(
      userSKillListing?.bid?.length > 0 &&
      userSKillListing?.bid?.[0]?.IdealStartDate).
      format("MMMM DD, YYYY")}

      //desired_rate={userSKillListing?.bid[0]?.Rate}
      desired_rate={desired_rate}
      Bid_rate={
      bidUpdateSuccess?.Rate ?
      bidUpdateSuccess?.Rate :
      userSKillListing?.bid?.length > 0 &&
      userSKillListing?.bid?.[0]?.Rate}

      BidId={
      userSKillListing?.bid?.length > 0 && userSKillListing?.bid?.[userSKillListing?.bid?.length - 1]?.BidId}

      selectedCandidates={candidateList()}
      SkillListingId={userSKillListing?.skill_listings?.SkillListingId}
      frompdetail={true}
      jobId={props?.jobId}
      jobdetails={props?.jobdetails}
      HidePagePvt={props?.HidePagePvt}
      setHidePagePvt={props?.setHidePagePvt}
      fromDetailPage={true} />
      

      <Row style={{ textAlign: "center", width: "100%", margin: "auto" }}>
        <Col className="edit-btn-div" xs={12}>
          <Button
          className="edit-bid-btn"
          onClick={showModal2}
          aria-details={
          !!PosbidStatuses[
          userSKillListing?.bid?.length > 0 &&
          userSKillListing?.bid?.[userSKillListing?.bid?.length - 1]?.
          BidStatusId] &&
          "disabled"}

          disabled={
          !!PosbidStatuses[
          userSKillListing?.bid?.length > 0 &&
          userSKillListing?.bid?.[userSKillListing?.bid?.length - 1]?.
          BidStatusId]}>


            
            Edit bid
          </Button>
        </Col>
        <Col className="retract-bid-btn-div" xs={12}>
          <Button
          className="retract-btn"
          onClick={showModal}
          aria-details={
          !!PosbidStatuses[
          userSKillListing?.bid?.length > 0 &&
          userSKillListing?.bid?.[userSKillListing?.bid?.length - 1]?.
          BidStatusId] &&
          "disabled"}

          disabled={
          !!PosbidStatuses[
          userSKillListing?.bid?.length > 0 &&
          userSKillListing?.bid?.[userSKillListing?.bid?.length - 1]?.
          BidStatusId]}>


            
            Retract bid
          </Button>
        </Col>
      </Row>
    </>);

};

export const MatchesButton = (props) => {
  const { match, setMatch, SkillListingId, isTalentSuggestion = false } = props;
  const [addedToMatch, setAddedToMatch] = useState(match);
  const [buttonPressed, setButtonPressed] = useState(false);

  const dispatch = useDispatch();
  const userSKillListing = useSelector(
  (state) => state.oneUserskillListingReducer.skillListings);

  const addMatchloading = useSelector(
  (state) => state.MatchedSkillReducer.loading);

  const { success } = useSelector((state) => state.MatchedSkillReducer);

  const jobdetails = useSelector(
  (state) => state.getJobDetailReducer.jobdetails);





  const addtoMatches = () => {
    try {setButtonPressed(true);
      const gigDetail = getGigDetails();
      dispatch(
      addToMatches({
        GigId: props.GigId || gigDetail?.JobOrderId,
        JobTitle: props.JobTitle || gigDetail?.Title,
        SkillListingId: props.SkillListingId,
        SkillListingTitle: props.SkillListingTitle
      }));

      setAddedToMatch(true);

      setTimeout(() => {
        dispatch(clearMatchesSuccess());
        setButtonPressed(false);
      }, 5000);} catch (err) {}
  };

  const removefromMatches = () => {
    const gigDetail = getGigDetails();
    setButtonPressed(true);
    setAddedToMatch(false);
    dispatch(
    removeFromMatches({
      SkillListingId: SkillListingId,
      GigId: props.GigId || gigDetail?.JobOrderId
    }));

    setTimeout(() => {
      dispatch(clearMatchesSuccess());
      setButtonPressed(false);
    }, 5000);
  };

  useEffect(() => {
    if (userSKillListing?.isMatch == true && addedToMatch == false) {
      setAddedToMatch(true);
      setButtonPressed(true);
    } else if (userSKillListing?.isMatch == false && addedToMatch == true) {
      setAddedToMatch(false);
    }
  }, [userSKillListing]);

  const findMatches = () => {
    dispatch(getSkillMatches(props.GigId));
    history.goBack();
  };

  useEffect(() => {
    if (match == true && addedToMatch == false) {
      setAddedToMatch(true);
      setButtonPressed(true);
    }
  }, [addedToMatch]);
  return (
    <>
      {/* {success && buttonPressed ? (
          <TopAlert
            display={"flex"}
            title={
              !addedToMatch
                ? "Matched candidate successfully removed from your job."
                : "Candidate successfully matched to your job."
            }
            type="success"
          />
         ) : null} */}
      {isTalentSuggestion ? null :
      <div style={{ width: "100%" }}>
          <button className={"add-match-btn"} onClick={() => findMatches()}>
            Back to matches
          </button>
        </div>}
      

      <div style={{ width: "100%" }} onClick={() => setMatch(!match)}>
        <button
        className={addedToMatch ? "removefromMatch" : "add-match-btn"}
        onClick={addedToMatch ? removefromMatches : addtoMatches}
        // style={removebtnmatch}
        >
          {addMatchloading ?
          <LoadingOutlined /> :
          addedToMatch ?
          "Remove from my matches" :

          "Add to matches"}
          
        </button>
      </div>
    </>);

};